"use client";
import Dashboard from "@/components/dashboard";
import { CircularProgress } from "@heroui/react";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function Home() {
  const router = useRouter();
  const { data: session, status } = useSession();
  const [logged, setLogged] = useState(false);

  useEffect(() => {
    if (status === "loading") return;
    if (status === "unauthenticated") {
      router.push("/login");
    } else {
      setLogged(true);
    }
  }, [status, router]);

  return (
    <>
      {logged ? (
        <Dashboard />
      ) : (
        <div className="h-screen w-full flex justify-center items-center">
          <CircularProgress size="lg" />
        </div>
      )}
    </>
  );
}
